import Flickity from 'flickity';
const FlickitySlider = () => {

    Flickity.prototype.ontouchstart = (function(original) {
        return function(event) {
            this._pointerUp(event, event.changedTouches[0]);
            original.apply(this, arguments);
        };
    }(Flickity.prototype.ontouchstart));

    Flickity.prototype._createResizeClass = function () {
        this.element.classList.add('flickity-resize');
    };

    Flickity.createMethods.push('_createResizeClass');

    var resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function () {
        this.element.classList.remove('flickity-resize');
        resize.call(this);
        this.element.classList.add('flickity-resize');
    };

    const slider = document.querySelectorAll(
        '.c-image-with-caption-slider .c-image-with-caption__container');

    function flickitySlider () {
        const $carousel = new Flickity(slider[0], {
            cellSelector: '.c-image-with-caption .o-container .c-image-with-caption__row',
            draggable: '>1',
            wrapAround: false,
            prevNextButtons: true,
            pageDots: false,
            adaptiveHeight: false
        });

        slider[0].addEventListener( 'dragStart.flickity', function( event, pointer ) {
            document.ontouchmove = function (e) {
                e.preventDefault();
            }
        });
        slider[0].addEventListener( 'dragEnd.flickity', function( event, pointer ) {
            document.ontouchmove = function (e) {
                return true;
            }
        });
    }
    if (slider.length > 0) {
        flickitySlider();
    }

}

export default FlickitySlider
